const state = {
  errorTips: {
    isVisible: false,
    data: [],
    title: '',
    subTitle: ''
  }
}
const mutations = {
  setErrorTips: (state, payload) => {
    state.errorTips = payload;
  },
}

export default {
  namespaced: true,
  state,
  mutations
}
